import Nav from "../other/nav/nav.jsx";
import Index from "../main/hero/hero.jsx";
import Activity from "../main/activity/activity.jsx";
import Team from "../main/team/team.jsx";
import Service, { ServicePart2 } from "../main/service/service.jsx";
import Realisation from "../main/realisation/realisation.jsx";
import Knowlege from "../main/knowlege/knowlege.jsx";
import Avis from "../main/avis/avis.jsx";
import Contact from "../main/contact/contact.jsx";

export default function IndexPage() {
  return (
    <div className="index-page">
      <Nav />
      <Index />
      <Activity />
      <Team />
      <Service />
      {/* <ServicePart2 /> */}
      <Realisation />
      <Knowlege />
      <Avis />
      <Contact />
    </div>
  );
}
